import { isEmpty, isArray } from 'lodash';
import WorkatoClient from '../../clients/WorkatoClient';
import WorkatoModel from '../../models/WorkatoModel';
import WorkatoAccount from '../../models/WorkatoAccount';
import WorkatoAdmin from '../../models/WorkatoAdminModel';
import WorkatoUser from '../../models/WorkatoUser';
import WorkatoRecipe from '../../models/WorkatoRecipe';

function transformWorkatoTokenResponse(response) {
  let workatoToken = null;
  if (!isEmpty(response)) {
    const responseData = response;
    workatoToken = new WorkatoModel({ ...responseData });
  }
  return workatoToken;
}
function transformWorkatoRecipeResponse(response) {
  let workatoRecipe = null;
  if (!isEmpty(response)) {
    workatoRecipe = new WorkatoRecipe({ ...response });
  }
  return workatoRecipe;
}
function transformWorkatoAdminsResponse(response) {
  const workatoToken = [];
  if (!isEmpty(response) && response.data && response.data.length > 0) {
    const responseData = response.data;
    responseData.forEach((data) => {
      workatoToken.push(new WorkatoAdmin({ ...data }));
    });
  }
  return workatoToken;
}

function transformExistingWorkatoAccountResponse(response) {
  let existingWorkatoAccount = null;
  if (!isEmpty(response)) {
    existingWorkatoAccount = new WorkatoAccount({ ...response });
  }
  return existingWorkatoAccount;
}

function transformExistingWorkatoUserResponse(response) {
  let existingWorkatoUser = null;
  if (!isEmpty(response)) {
    existingWorkatoUser = new WorkatoUser({ ...response });
  }
  return existingWorkatoUser;
}
// New Workato User
function transformNewWorkatoUserRequest() {
  return {
    body: {},
    method: WorkatoClient.HTTP_METHODS.PUT,
  };
}
function transformNewWorkatoUserResponse(response) {
  let newWorkatoUser = null;
  if (!isEmpty(response)) {
    newWorkatoUser = response.data;
  }
  return newWorkatoUser;
}
// New Workato Account
function transformNewWorkatoAccountRequest() {
  return {
    body: {},
    method: WorkatoClient.HTTP_METHODS.PUT,
  };
}
function transformNewWorkatoAccountResponse(response) {
  let newWorkatoAccount = null;
  if (!isEmpty(response)) {
    newWorkatoAccount = response.data;
  }
  return newWorkatoAccount;
}
function transformImportWorkatoRecipeResponse(response) {
  let importWorkatoRecipe = null;
  if (!isEmpty(response)) {
    importWorkatoRecipe = response.data;
  }
  return importWorkatoRecipe;
}
function transformIhubConfigResponse(response) {
  let ihubConfig = null;
  if (!isEmpty(response)) {
    ihubConfig = response.data;
  }
  return ihubConfig;
}

function transformOnboardingPopupRequest(body, created) {
  const settings = {
    method: created ? WorkatoClient.HTTP_METHODS.PUT : WorkatoClient.HTTP_METHODS.POST,
  };
  return {
    body,
    ...settings,
  };
}

function transformWorkatoConfigsResponse(response, configName) {
  const ihubConfig = {
    created: false,
    value: false,
  };
  if (!isEmpty(response) && !isEmpty(configName)) {
    let configData;
    if (isArray(response.data)) {
      configData = response.data.find(({ config_name: cn }) => cn === configName);
    } else {
      configData = response.data;
    }
    if (configData) {
      ihubConfig.created = true;
      ihubConfig.value = !!configData.config_value && !(configData.config_value === '0' || configData.config_value === 'false');
    }
  }
  return ihubConfig;
}

export default {
  transformWorkatoTokenResponse,
  transformWorkatoRecipeResponse,
  transformWorkatoAdminsResponse,
  transformExistingWorkatoAccountResponse,
  transformExistingWorkatoUserResponse,
  transformNewWorkatoUserRequest,
  transformNewWorkatoUserResponse,
  transformNewWorkatoAccountRequest,
  transformNewWorkatoAccountResponse,
  transformIhubConfigResponse,
  transformImportWorkatoRecipeResponse,
  transformOnboardingPopupRequest,
  transformWorkatoConfigsResponse,
};
